import { AxiosStatic, AxiosResponse } from 'axios';
import { EocEmailConfig } from './EocEmailConfig';
import VersionedResource from '../VersionedResource';

export default class EocEmailConfigResource extends VersionedResource {
  public async get(fiId: string) : Promise<EocEmailConfig> {
    const url = `/api/rcx/config/${fiId}/eoc-email-settings`;

    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if EocEmailConfig has not been set up yet, so return empty EocEmailConfig
      if (error.response.status !== 404) {
        throw error;
      } else {
        return EocEmailConfigResource.createEmptyEocEmailConfig();
      }
    }
  }

  public async update(fiId: string, data:EocEmailConfig):
    Promise<EocEmailConfig> {
    const url = `/api/rcx/config/${fiId}/eoc-email-settings`;
    const response: AxiosResponse = await this.apiClient.put(url, data);
    return response.data.data;
  }

  public static createEmptyEocEmailConfig() : EocEmailConfig {
    return {
      fiName: '',
      bankOrCu: 'BANK',
      accountholderNomenclature: '',
      fromEmailAddress: '',
      fiContactPhone: '',
      fiContactEmail: '',
      fiHomePageUrl: '',
      logoUrl: '',
      insuranceLogo: null,
      ehlEnabled: false,
      housingLogo: null,
      facebookLink: null,
      twitterLink: null,
      linkedinLink: null,
      bannerColor: '',
      lastSentDate: '',
      enableConfidentialityStatement: true,
      fiHomePageUrlManualVerified: false,
      emailProvider: 'SPARKPOST',
      batchSize: 50,
      fromSfmcEmailUsername: '',
      fromSfmcEmailDomain: '@email.rewardlocally.com',
      pinPointEnabled: false,
      fiCyrUrl: null,
      fiShortCyrUrl: null,
      fiDashboardUrl: null,
      fiShortDashboardUrl: null,
      fiVasaDashboardFullUrl: null,
      fiVasaDashboardShortUrl: null,
    };
  }
}
